import React from "react";
import { Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { MdSettings } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faNetworkWired,
  faTruckFast,
  faFileLines,
  faChartLine,
  faSquarePollHorizontal,
  faUserLock,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

// صفحات
import Home from "../../Pages/Home/Home";
import USERS_PERMISSIONS from "../../Pages/Permission/USER_Permission";
import Permission from "../../Pages/Permission/Permission";
import USERS from "../../Pages/Advanced_Settings/USERS";
import Branch from "../../Pages/Advanced_Settings/Branch";

// تقارير
import GET_USER_DETAILS_ALL_REPORTS from "../../Pages/Report/Monitor_Screen/GET_USER_DETAILS_ALL_REPORTS";
import USER_DETAILS_DELETE_REPORTS from "../../Pages/Report/Monitor_Screen/USER_DETAILS_DELETE_REPORTS";
import INVOICE_USERS_REPORT from "../../Pages/Report/Users/Invoice_Users_Report";
import ORDERS_USERS_REPORT from "../../Pages/Report/Users/Orders_Users_Report";
import ITEMS_REPORT from "../../Pages/Report/Items/Items_Report";
import CATEGORY_SALES_REPORT from "../../Pages/Report/Items/CATEGORY_Report";
import ITEM_STORE_REPORT from "../../Pages/Report/Items/ITEM_STORE_REPORT";
import SALES_REPORT_HOURLY from "../../Pages/Report/SALES/SALES_REPORT_HOURLY";
import SALES_REPORT_DAY from "../../Pages/Report/SALES/SALES_REPORT_DAY";
import SALES_REPORT_DAY_WEEK from "../../Pages/Report/SALES/SALES_REPORT_WEEK_DAY";
import SALES_REPORT_MONTH from "../../Pages/Report/SALES/SALES_REPORT_MONTH";
import SALES_REPORT_YEARLY_QUARTERLY from "../../Pages/Report/SALES/SALES_REPORT_YEARLY_QUARTERLY";
import SALES_REPORT_YEAR from "../../Pages/Report/SALES/SALES_REPORT_YEAR";
import INVOICE_SALES from "../../Pages/Report/SALES/INVOICE_SALES";
import IVC_SALES_REORT from "../../Pages/Report/SALES/IVC_SALES";
import ERADAT_REPORT from "../../Pages/Report/SALES/ERADAT_REPORT";
import EXPENSES_REPORT from "../../Pages/Report/SALES/EXPENSES_REPORT";
import INVOICE_TYPE_REPORT from "../../Pages/Report/SALES/INVOICE_TYPE_REPORT";
import INVOICE_FINAL_SALES_REPORT from "../../Pages/Report/SALES/INVOICE_FINAL_SALES_REPORT";
import APPLICATION_SALES from "../../Pages/Report/SALES/APPLICATION_SALES";
import CAPTIN_SALES from "../../Pages/Report/SALES/CAPTIN_SALES";
import SALES_DELIVERY_RETURN from "../../Pages/Report/SALES/SALES_DELIVERY_RETURN";

const Routes = () => {
  const { t } = useTranslation();
  const type = localStorage.getItem("type");
  const permission = JSON.parse(localStorage.getItem("PERMISSION") || "{}");

  const hasPermission = (key) => {
    return type === "MAIN" || permission.PERMISSION_ALL === true || Object.keys(permission).length === 0 || permission[key] === true;
  };

  const routes = [];

  // ✅ الصفحة الرئيسية
  if (hasPermission("Home")) {
    routes.push({
      path: t("Home"),
      name: t("Home"),
      icon: <FontAwesomeIcon icon={faChartLine} />,
      component: <Home />,
    });
  }



  // ✅ تقارير المبيعات حسب الفترات
  const salesReportForSubRoutes = [
    hasPermission("SALES_REPORT_HOURLY") && {
      path: t("SALES_REPORT_HOURLY"),
      name: t("SALES_REPORT_HOURLY"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_REPORT_HOURLY />,
    },
    hasPermission("SALES_REPORT_DAY") && {
      path: t("SALES_REPORT_DAY"),
      name: t("SALES_REPORT_DAY"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_REPORT_DAY />,
    },
    hasPermission("SALES_REPORT_DAY_WEEK") && {
      path: t("SALES_REPORT_DAY_WEEK"),
      name: t("SALES_REPORT_DAY_WEEK"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_REPORT_DAY_WEEK />,
    },
    hasPermission("SALES_REPORT_MONTH") && {
      path: t("SALES_REPORT_MONTH"),
      name: t("SALES_REPORT_MONTH"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_REPORT_MONTH />,
    },
    hasPermission("SALES_REPORT_YEARLY_QUARTERLY") && {
      path: t("SALES_REPORT_YEARLY_QUARTERLY"),
      name: t("SALES_REPORT_YEARLY_QUARTERLY"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_REPORT_YEARLY_QUARTERLY />,
    },
    hasPermission("SALES_REPORT_YEAR") && {
      path: t("SALES_REPORT_YEAR"),
      name: t("SALES_REPORT_YEAR"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_REPORT_YEAR />,
    },
  ].filter(Boolean);

  // ✅ تقارير المبيعات العامة
  const salesReportSubRoutes = [
    hasPermission("INVOICE_SALES") && {
      path: t("INVOICE_SALES"),
      name: t("INVOICE_SALES"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <INVOICE_SALES />,
    },
    hasPermission("SALES_DELIVERY_RETURN") && {
      path: t("SALES_DELIVERY_RETURN"),
      name: t("SALES_DELIVERY_RETURN"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <SALES_DELIVERY_RETURN />,
    },
    hasPermission("IVC_SALES_REORT") && {
      path: t("IVC_SALES_REORT"),
      name: t("IVC_SALES_REORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <IVC_SALES_REORT />,
    },
    hasPermission("ERADAT_REPORT") && {
      path: t("ERADAT_REPORT"),
      name: t("ERADAT_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <ERADAT_REPORT />,
    },
    hasPermission("EXPENSES_REPORT") && {
      path: t("EXPENSES_REPORT"),
      name: t("EXPENSES_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <EXPENSES_REPORT />,
    },
    hasPermission("INVOICE_TYPE_REPORT") && {
      path: t("INVOICE_TYPE_REPORT"),
      name: t("INVOICE_TYPE_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <INVOICE_TYPE_REPORT />,
    },
    hasPermission("INVOICE_FINAL_SALES_REPORT") && {
      path: t("INVOICE_FINAL_SALES_REPORT"),
      name: t("INVOICE_FINAL_SALES_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <INVOICE_FINAL_SALES_REPORT />,
    },
    hasPermission("APPLICATION_SALES") && {
      path: t("APPLICATION_SALES"),
      name: t("APPLICATION_SALES"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <APPLICATION_SALES />,
    },
    hasPermission("CAPTIN_SALES") && {
      path: t("CAPTIN_SALES"),
      name: t("CAPTIN_SALES"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <CAPTIN_SALES />,
    },
  ].filter(Boolean);

  // ✅ جميع التقارير تحت قسم "Report"
  const reportRoutes = [];

  if (salesReportForSubRoutes.length > 0) {
    reportRoutes.push({
      path: t("SALES_REPORT_FOR"),
      name: t("SALES_REPORT_FOR"),
      icon: <FontAwesomeIcon icon={faSquarePollHorizontal} />,
      subRoutes: salesReportForSubRoutes,
    });
  }

  if (salesReportSubRoutes.length > 0) {
    reportRoutes.push({
      path: t("SALES_REPORT"),
      name: t("SALES_REPORT"),
      icon: <FontAwesomeIcon icon={faSquarePollHorizontal} />,
      subRoutes: salesReportSubRoutes,
    });
  }

  // ✅ تقارير المنتجات
  const itemReports = [
    hasPermission("ITEMS_SALES_REPORT") && {
      path: t("ITEMS_SALES_REPORT"),
      name: t("ITEMS_SALES_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <ITEMS_REPORT />,
    },
    hasPermission("CATEGORY_SALES_REPORT") && {
      path: t("CATEGORY_SALES_REPORT"),
      name: t("CATEGORY_SALES_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <CATEGORY_SALES_REPORT />,
    },
  ].filter(Boolean);

  if (itemReports.length > 0) {
    reportRoutes.push({
      path: t("ITEMS_REPORTS"),
      name: t("ITEMS_REPORTS"),
      icon: <FontAwesomeIcon icon={faSquarePollHorizontal} />,
      subRoutes: itemReports,
    });
  }

  // ✅ تقارير المستخدمين
  const userReports = [
    hasPermission("ORDERS_USERS_REPORT") && {
      path: t("ORDERS_USERS_REPORT"),
      name: t("ORDERS_USERS_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <ORDERS_USERS_REPORT />,
    },
    hasPermission("INVOICE_USERS_REPORT") && {
      path: t("INVOICE_USERS_REPORT"),
      name: t("INVOICE_USERS_REPORT"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <INVOICE_USERS_REPORT />,
    },
  ].filter(Boolean);

  if (userReports.length > 0) {
    reportRoutes.push({
      path: t("User_Report"),
      name: t("User_Report"),
      icon: <FontAwesomeIcon icon={faSquarePollHorizontal} />,
      subRoutes: userReports,
    });
  }

  // ✅ تقارير المخزن
  if (hasPermission("ITEM_STORE_Report")) {
    reportRoutes.push({
      path: t("STORE_Report"),
      name: t("STORE_Report"),
      icon: <FontAwesomeIcon icon={faSquarePollHorizontal} />,
      subRoutes: [
        {
          path: t("ITEM_STORE_Report"),
          name: t("ITEM_STORE_Report"),
          icon: <FontAwesomeIcon icon={faFileLines} />,
          component: <ITEM_STORE_REPORT />,
        },
      ],
    });
  }

  if (reportRoutes.length > 0) {
    routes.push({
      path: t("Report"),
      name: t("Report"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      trailing: <FontAwesomeIcon icon={faTruckFast} />,
      subRoutes: reportRoutes,
    });
  }

  // ✅ شاشة المراقبة
  const monitorRoutes = [
    hasPermission("Monitor_Screen_Report") && {
      path: t("Monitor_Screen_Report"),
      name: t("Monitor_Screen_Report"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <GET_USER_DETAILS_ALL_REPORTS />,
    },
    hasPermission("Deletion_And_Monitor_Report") && {
      path: t("Deletion_And_Monitor_Report"),
      name: t("Deletion_And_Monitor_Report"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      component: <USER_DETAILS_DELETE_REPORTS />,
    },
  ].filter(Boolean);

  if (monitorRoutes.length > 0) {
    routes.push({
      path: t("Monitor_Screen"),
      name: t("Monitor_Screen"),
      icon: <FontAwesomeIcon icon={faFileLines} />,
      trailing: <FontAwesomeIcon icon={faTruckFast} />,
      subRoutes: monitorRoutes,
    });
  }

  const settingRoutes = [
    type === "MAIN" && {
      path: t("Branch"),
      name: t("Branch"),
      icon: <FontAwesomeIcon icon={faNetworkWired} />,
      component: <Branch />,
    },
    type === "MAIN" && {
      path: t("Permissions"),
      name: t("Permissions"),
      icon: <FontAwesomeIcon icon={faUserLock} />,
      component: <Permission />,
    },



    type === "SUB" && {
      path: t("USERS"),
      name: t("USERS"),
      icon: <FontAwesomeIcon icon={faUsers} />,
      component: <USERS />,
    },

    type === "SUB" && {
      path: t("USERS_PERMISSIONS"),
      name: t("USERS_PERMISSIONS"),
      icon: <FontAwesomeIcon icon={faUserLock} />,
      component: <USERS_PERMISSIONS />,
    },
  ].filter(Boolean);

  if (type === "MAIN" || type === "SUB") {
    routes.push({
      path: t("Setting"),
      name: t("Setting"),
      icon: <Icon as={MdSettings} />,
      trailing: <Icon as={MdSettings} />,
      subRoutes: settingRoutes,
    });
  }

  return routes;
};

export default Routes;
